import { render, staticRenderFns } from "./RemoveItem.vue?vue&type=template&id=db9710ee"
import script from "./RemoveItem.vue?vue&type=script&lang=js"
export * from "./RemoveItem.vue?vue&type=script&lang=js"
import style0 from "./RemoveItem.vue?vue&type=style&index=0&id=db9710ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports